module.exports = __webpack_public_path__ + "media/images/piggy-d20c05ae6e9fe47e28a0fd6331389840.png";